module.exports = __webpack_public_path__ + "img/Close.8b550f9c.svg";